import { env } from '../../lib/env/env';

export const legacyC2foUiConfig = {
  LEGACY_C2FO_UI_BASE_URL: env.getString('LEGACY_C2FO_UI_BASE_URL') || 'http://localhost:8089',
};
